"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getRadioButtonsInitialValues = exports.getRadioButtonsValidator = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _radio = _interopRequireDefault(require("../radio"));

require("./mad-lib-radio-buttons.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @typedef {object} RadioOption
 * @property {string} label
 * @property {string} value
 */

/**
 * @typedef {object} FormikApi
 * @property {object} values
 */

/**
 * Formik API passed to component by `connect` -
 * https://jaredpalmer.com/formik/docs/1.4.4/api/connect
 */
var formikPropType = _propTypes["default"].shape({
  values: _propTypes["default"].object
});
/**
 * Similar to a select menu interface, but renders buttons
 */


var optionPropType = _propTypes["default"].shape({
  label: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired
}); // UI strings and constants


var otherOptionValue = 'other';
var otherOptionFieldNameSuffix = '_other';
var otherLabel = '**Other** - ';
var otherPlaceholder = 'Make a suggestion...';
var optionIsRequiredError = 'Select an option.';
var fieldIsRequiredError = 'This field is required.';
/**
 * Return a Formik validate function for the provided field name.
 * @param {string} name
 */

var getRadioButtonsValidator = function getRadioButtonsValidator(name) {
  return (
    /**
     * Ensures that the user has selected a value for the radio buttons form type.
     * @param {object} formValues
     * @param {string} name Radio button field name
     */
    function (formValues) {
      var errors = {};

      if (formValues) {
        var otherFieldInputName = "".concat(name).concat(otherOptionFieldNameSuffix);
        var value = formValues[name];
        var otherFieldInputValue = formValues[otherFieldInputName];

        if (!value) {
          errors[name] = optionIsRequiredError;
        } else if (value === otherOptionValue && !otherFieldInputValue) {
          errors[otherFieldInputName] = fieldIsRequiredError;
        }
      }

      return errors;
    }
  );
};
/**
 * Get initial form values. Initial values are required for Formik validation to
 * work as expected.
 * @param {string} name
 */


exports.getRadioButtonsValidator = getRadioButtonsValidator;

var getRadioButtonsInitialValues = function getRadioButtonsInitialValues(name) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, name, ''), _defineProperty(_ref, "".concat(name).concat(otherOptionFieldNameSuffix), ''), _ref;
};
/**
 * Single radio button
 * @param {object} props
 * @param {FormikApi} [props.formik]
 * @param {string} [props.name] Input name, same for all radio buttons in the
 * group
 * @param {RadioOption} [props.option] Contains label for the radio, which can be
 * markdown, and the value to use on the <input />
 * @param {React.ReactNode} [props.children] Optional children to be rendered next to
 * the label, used to render the freeform answer input
 */


exports.getRadioButtonsInitialValues = getRadioButtonsInitialValues;

var MadLibRadioButton = function MadLibRadioButton(_ref2) {
  var formik = _ref2.formik,
      name = _ref2.name,
      option = _ref2.option,
      children = _ref2.children;
  var id = "".concat(name, "-").concat(option.value);
  var checked = formik.values[name] === option.value;
  var inputProp = {
    name: name,
    value: option.value,
    checked: checked
  };

  var labelMarkdown = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    source: option.label
  }), children);

  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    key: id,
    name: name,
    type: "radio" // eslint-disable-next-line react/jsx-no-bind
    ,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/_react["default"].createElement(_radio["default"], {
        className: (0, _classnames["default"])('madLibRadioButton', {
          selected: checked
        }),
        label: labelMarkdown,
        input: _objectSpread(_objectSpread({}, field), inputProp)
      });
    }
  });
};

MadLibRadioButton.propTypes = {
  formik: formikPropType,
  name: _propTypes["default"].string,
  option: optionPropType,
  children: _propTypes["default"].element
};
MadLibRadioButton.defaultProps = {
  formik: {
    values: {}
  },
  name: '',
  option: {
    label: '',
    value: ''
  },
  children: null
};
/**
 * Freeform text input that appears next to the `other` option
 * @param {object} props
 * @param {FormikApi} [props.formik]
 * @param {string} [props.name]
 * @param {string} [props.placeholder]
 */

var MadLibRadioButtonOtherInput = function MadLibRadioButtonOtherInput(_ref4) {
  var formik = _ref4.formik,
      name = _ref4.name,
      placeholder = _ref4.placeholder;
  var otherChecked = formik.values[name] === otherOptionValue;
  var fieldName = "".concat(name).concat(otherOptionFieldNameSuffix);
  var otherInputValue = formik.values[fieldName];
  var componentRef = (0, _react.useRef)(null); // Focus input when radio is selected

  (0, _react.useEffect)(function () {
    if (!otherChecked) return;
    var inputElement = componentRef.current.querySelector('input');
    if (!inputElement) return;
    inputElement.select();
  }, [otherChecked]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    key: "name",
    className: "otherInput",
    ref: componentRef
  }, otherChecked ? /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    className: "input",
    type: "text",
    name: fieldName,
    placeholder: placeholder,
    disabled: !otherChecked
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "otherInputPlaceholder"
  }, otherInputValue || placeholder), /*#__PURE__*/_react["default"].createElement("span", {
    className: "errorMessage"
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: fieldName
  })));
};

MadLibRadioButtonOtherInput.propTypes = {
  formik: formikPropType,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
};
MadLibRadioButtonOtherInput.defaultProps = {
  formik: {
    values: {}
  },
  name: '',
  placeholder: ''
};
/**
 * List of radio buttons with an additional freeform `other` option added at the end.
 * @param {object} props
 * @param {FormikApi} [props.formik]
 * @param {string} [props.name] Name of the form value that will be populated by radio selection
 * @param {boolean} [props.includeOtherOption] If true, include an "Other" option with a freeform
 * input
 * @param {RadioOption[]} [props.options] List of radio button options with labels and values
 */

var MadLibRadioButtons = function MadLibRadioButtons(_ref5) {
  var formik = _ref5.formik,
      name = _ref5.name,
      includeOtherOption = _ref5.includeOtherOption,
      options = _ref5.options;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "MadLibRadioButtons"
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(MadLibRadioButton, {
      key: "".concat(name, "-").concat(option.value),
      formik: formik,
      name: name,
      option: option
    });
  }), includeOtherOption ? /*#__PURE__*/_react["default"].createElement(MadLibRadioButton, {
    formik: formik,
    name: name,
    option: {
      value: otherOptionValue,
      label: otherLabel
    }
  }, /*#__PURE__*/_react["default"].createElement(MadLibRadioButtonOtherInput, {
    formik: formik,
    name: name,
    placeholder: otherPlaceholder
  })) : null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "errorMessage"
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: name
  })));
};

MadLibRadioButtons.propTypes = {
  formik: formikPropType,
  name: _propTypes["default"].string,
  includeOtherOption: _propTypes["default"].bool,
  options: _propTypes["default"].arrayOf(optionPropType)
};
MadLibRadioButtons.defaultProps = {
  formik: {
    values: {}
  },
  name: '',
  includeOtherOption: true,
  options: []
};

var _default = (0, _formik.connect)(MadLibRadioButtons);

exports["default"] = _default;